import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { ThNavHeader } from './ThNavHeader';
import { ThNavFooter } from './ThNavFooter';
import ThUserMenu from './ThUserMenu';

import { getClientId } from './utils/analyticsclientIdUtils';
import { encryptData } from './utils/encryptionUtils';

import { validateNameENTH } from './utils/validatePassword';

export class ThUserProfile20 extends Component {
    static displayName = ThUserProfile20.name;

    constructor(props) {
        super(props);

        this.otpInputRefs = [];

        this.state = {
            userData: null, // Initialize userData state to null
            userInfo: null,
            birthdayd: '',
            birthdaym: '',
            submitting: false,
            salutation: '',
            firstname: '',
            lastname: '',
            firstnameth: '',
            lastnameth: '',
            mobile: '',
            submittingProfile: false,
            successMsg: '',
            failMsg: '',
            failMsg2: '',
            registerMsgFname: '',
            registerMsgLname: '',
            actionSuccess: false,
            disabledBtnOtp: true,//SR2.0 param start here
            disabledBtnSubmit: true,
            languagePreference: '',
            receiveNews: false,
            receiveNewsSMS: false,
            receiveNewsEmail: false,
            receiveNewsCss: 'mb-3 ps-0 d-none',
            showOtpModal: false,//OTP Modal
            otpValues: ['', '', '', '', '', ''],
            otpTimeLeft: 60,
            otpCanResend: false,
            otpRefCode: '',
            otpMessage: '',
            otpTimerId: null,
            mobileVerified: false,
            otpRunId: '',
            otpMaxError: false,
            registerMsgLanguage: '',
            registerMsgReceive: '',
            registerMsgAgree: '',
            agree1: false,
            verifiedMobileNumber: '',
            isEditMobile: false,
            newMobile: ""
        };
    }

    componentDidMount() {
        // Retrieve data from session storage
        const userDataFromStorage = sessionStorage.getItem('userData');

        // Parse the data if it exists and set it to the component state
        if (userDataFromStorage) {
            const parsedUserData = JSON.parse(userDataFromStorage);
            this.setState({ userData: parsedUserData }, () => {
                // After setting the state, make the API call if userData is available
                if (this.state.userData && this.state.userData.loyaltyMemberId) {
                    this.callApiWithUserId(this.state.userData.loyaltyMemberId);
                }
            });
        }

        {
            // Google analytic
            const documentPath = "TH Profile"; // Gets the current URL path
            const clientId = getClientId(); // Use the getClientId function

            // Push data to the GTM dataLayer
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'pageview',
                page: documentPath,
                clientId: clientId,
            });
        }
    }

    componentWillUnmount() {
        if (this.state.otpTimerId) {
            clearInterval(this.state.otpTimerId);
        }
    }

    async callApiWithUserId(userId) {
        // Add the wait cursor class to the body element
        //document.body.classList.add('wait-cursor');

        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        // Prepare and encrypt the payload
        const payload = { UserId: userId, RefLang: "th", Timestamp: timestamp };
        const encryptedPayload = encryptData(payload);

        const token = this.state.userData.token;

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/CrmMemberGetInfo`, requestOptions);
            const data = await response.json();
            if (data) {
                let css01 = 'mb-3 ps-0 d-none';
                if (data.optInMarketing) {
                    css01 = 'mb-3 ps-0';
                }

                let chkmobileVerified = false;
                if (data.verifiedMobileNumber !== null) {
                    chkmobileVerified = true;
                }

                data.salutation = data.salutation == null ? "" : data.salutation;
                this.setState({ userInfo: data, salutation: data.salutation, firstname: data.firstName, lastname: data.lastName, firstnameth: data.firstNameTH, lastnameth: data.lastNameTH, mobile: data.mobilePhone, languagePreference: data.languagePreference, verifiedMobileNumber: data.verifiedMobileNumber, receiveNews: data.optInMarketing, receiveNewsEmail: data.optInEmail, receiveNewsSMS: data.optInSMS, receiveNewsCss: css01, mobileVerified: chkmobileVerified });
                //console.log(data);
            }
            else {
                console.error('Error data:');
            }
        } catch (error) {
            console.error('API call error :', error);
        } finally {
            //document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
        }
    }

    handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // checkbox
        if (type === "checkbox") {
            if (name === "receiveNews") {
                let css01 = 'mb-3 ps-0 d-none';
                if (checked) {
                    css01 = 'mb-3 ps-0';
                }

                this.setState(
                    { [name]: checked, receiveNewsCss: css01 },
                    () => this.chkEnableBtnSubmit()
                );
            }
            else {
                this.setState(
                    { [name]: checked },
                    () => this.chkEnableBtnSubmit()
                );
            }
            return;
        }

        // radio
        if (type === "radio") {
            this.setState(
                { [name]: value },
                () => this.chkEnableBtnSubmit()
            );
            return;
        }

        // text / number / other inputs
        let newValue = value;
        let errors = "";
        let errorsMobile = "";

        if (name === "mobile" || name === "newMobile") {
            newValue = value.replace(/\D/g, "").slice(0, 10);
            errorsMobile = this.validateMobileNumber(newValue);
        }

        // have some errorsMobile or newValue=verifiedMobileNumber -> disabledBtnOtp=true
        const newState = {
            [name]: newValue,
            registerMsgPwd: errors,
            disabledBtnOtp: (name === "mobile" || name === "newMobile")
                ? errorsMobile !== "" || newValue === this.state.verifiedMobileNumber
                : this.state.disabledBtnOtp
        };

        if (name === "birthdaym") {
            newState.birthdayd = "";
        }

        this.setState(newState, () => this.chkEnableBtnSubmit());
    };

    handleSubmitProfile = async e => {
        e.preventDefault();

        this.setState({
            successMsg: '', failMsg: '',
        });

        const { salutation, firstname, lastname, firstnameth, lastnameth, mobile, userInfo, languagePreference, receiveNews, receiveNewsSMS, receiveNewsEmail, agree1, birthdaym, birthdayd } = this.state;

        let canSubmit = true;
        let birthday = userInfo.birthday || null;

        if (!userInfo.displayBirthday) {

            // select only one value
            if (
                (birthdaym && !birthdayd) ||
                (!birthdaym && birthdayd)
            ) {
                this.setState({
                    failMsg2: "กรุณาระบุวันเกิดที่ถูกต้อง"
                });

                canSubmit = false;
            }

            // correct
            else if (birthdaym && birthdayd) {
                const month = String(birthdaym).padStart(2, "0");
                const day = String(birthdayd).padStart(2, "0");

                birthday = `1900-${month}-${day}`;
            }

            // not select at all ->null
            else {
                birthday = null;
            }
        }            

        //if (firstname === "") {
        //    this.setState({ registerMsgFname: "กรุณากรอก ชื่อ (อังกฤษ)" });
        //    canSubmit = false;
        //}

        //if (lastname === "") {
        //    this.setState({ registerMsgLname: "กรุณากรอก นามสกุล (อังกฤษ)" });
        //    canSubmit = false;
        //}
        const errorsEn01 = validateNameENTH(firstname);
        if (errorsEn01) {
            this.setState({ registerMsgFname: errorsEn01 });
            canSubmit = false;
        }

        const errorsEn02 = validateNameENTH(lastname);
        if (errorsEn02) {
            this.setState({ registerMsgLname: errorsEn02 });
            canSubmit = false;
        }

        // Mobile validation
        if (mobile && (!/^0\d{9}$/.test(mobile))) {
            this.setState({ registerMsgMobile: "กรุณากรอกเบอร์โทรศัพท์" });
            canSubmit = false;
        }

        if (languagePreference === "") {
            this.setState({ registerMsgLanguage: "กรุณาเลือกการตั้งค่าภาษา" });
            canSubmit = false;
        }

        //if (receiveNews === false) {
        //    this.setState({ registerMsgReceive: "Please select at least one option." });
        //    canSubmit = false;
        //}

        //if (receiveNewsSMS === false && receiveNewsEmail === false) {
        //    this.setState({ registerMsgReceive: "Please select at least one option." });
        //    canSubmit = false;
        //}

        // Only validate channels when user chooses to receive news
        if (receiveNews === true) {
            if (receiveNewsSMS === false && receiveNewsEmail === false) {
                this.setState({ registerMsgReceive: "กรุณาเลือกช่องทางที่คุณต้องการรับโปรโมชันและข่าวสารจากสตาร์บัคส์" });
                canSubmit = false;
            }
        }
        else {
            receiveNews = false;
            receiveNewsSMS = false;
            receiveNewsEmail = false;
        }

        if (agree1 === false) {
            this.setState({ registerMsgAgree: "กรุณายอมรับ นโยบายความเป็นส่วนตัวและข้อกำหนดการใช้งาน" });
            canSubmit = false;
        }

        if (canSubmit == false) {
            return;
        }

        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        // Prepare and encrypt the payload
        const payload = {
            LoyaltyMemberId: userInfo.loyaltyMemberId,
            Salutation: salutation,
            FirstName: firstname,
            LastName: lastname,
            FirstNameTH: firstnameth,
            LastNameTH: lastnameth,
            THNationalID: userInfo.thNationalID,
            Passport: userInfo.passport,
            MobilePhone: mobile,
            Birthday: birthday,
            Address1: userInfo.address1,
            Address2: userInfo.address2,
            Address3: userInfo.address3,
            City: userInfo.city,
            State: userInfo.state,
            PostalCode: userInfo.postalCode,
            Country: userInfo.country,
            OptInEmail: userInfo.optInEmail,
            RefLang: 'th',
            Timestamp: timestamp,
            LanguagePreference: languagePreference,//sr2.0
            OptInMarketing: !!receiveNews,
            OptInSMS: !!receiveNewsSMS,
            OptInEmail: !!receiveNewsEmail
        };
        const encryptedPayload = encryptData(payload);

        // Prevent double-clicking by disabling the submit button and changing cursor to 'wait'
        this.setState({ submittingProfile: true });

        // Add the wait cursor class to the body element
        document.body.classList.add('wait-cursor');

        const token = this.state.userData.token;

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/CrmMemberUpdateProfile`, requestOptions);
            const data = await response.json();
            if (data && data.statusCode === 'OK') {
                //this.setState({
                //    successMsg: 'Personal Info update Success.',
                //    actionSuccess: true
                //});
                this.setState(prevState => ({
                    successMsg: 'อัปเดตข้อมูลส่วนตัวแล้ว',
                    actionSuccess: true,
                    userInfo: {
                        ...prevState.userInfo,
                        birthday: birthday,
                        displayBirthday: birthday
                    }
                }));
            }
            else {
                //some error here
                this.setState({
                    failMsg: data.statusMsg,
                    actionSuccess: false
                });

                // Enable the submit button and change cursor back to 'auto' after form submission completes
                this.setState({ submittingProfile: false });
            }
            document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
        } catch (error) {
            console.error('Error during update profile:', error);
            // Handle error appropriately, e.g., show an error message to the user
        } finally {
            //document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
            this.setState({ submittingProfile: false });
            document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
        }
    };

    handleSubmit = async e => {
        e.preventDefault();
        const { birthdayd, birthdaym, userInfo } = this.state;

        if (!birthdaym || birthdaym === "") {
            this.setState({
                failMsg2: 'กรุณาระบุวันเกิดที่ถูกต้อง'
            });
            return;
        }

        if (!birthdayd || birthdayd === "") {
            this.setState({
                failMsg2: 'กรุณาระบุวันเกิดที่ถูกต้อง'
            });
            return;
        }

        const birthday = "1900-" + birthdaym + "-" + birthdayd;

        // Generate Unix timestamp
        const timestamp = Math.floor(Date.now() / 1000);

        // Prepare and encrypt the payload
        const payload = {
            LoyaltyMemberId: userInfo.loyaltyMemberId,
            Salutation: userInfo.salutation,
            FirstName: userInfo.firstName,
            LastName: userInfo.lastName,
            FirstNameTH: userInfo.firstNameTH,
            LastNameTH: userInfo.lastNameTH,
            THNationalID: userInfo.thNationalID,
            Passport: userInfo.passport,
            MobilePhone: userInfo.mobilePhone,
            Birthday: birthday,
            Address1: userInfo.address1,
            Address2: userInfo.address2,
            Address3: userInfo.address3,
            City: userInfo.city,
            State: userInfo.state,
            PostalCode: userInfo.postalCode,
            Country: userInfo.country,
            OptInEmail: userInfo.optInEmail,
            RefLang: 'th',
            Timestamp: timestamp
        };
        const encryptedPayload = encryptData(payload);

        // Prevent double-clicking by disabling the submit button and changing cursor to 'wait'
        this.setState({ submitting: true });

        // Add the wait cursor class to the body element
        document.body.classList.add('wait-cursor');

        const token = this.state.userData.token;

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ Data: encryptedPayload })
        };

        try {
            const response = await fetch(`/api/CrmMemberUpdateProfile`, requestOptions);
            const data = await response.json();
            if (data) {
                document.body.classList.remove('wait-cursor'); // Remove the wait cursor class

                window.location.replace("/thuserprofile");
            }
            else {
                // Enable the submit button and change cursor back to 'auto' after form submission completes
                this.setState({ submitting: false });
                document.body.classList.remove('wait-cursor'); // Remove the wait cursor class
            }
        } catch (error) {
            console.error('Error during update profile:', error);
            // Handle error appropriately, e.g., show an error message to the user
        } finally {

        }
    };

    formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    }

    validateMobileNumber = (mobile) => {
        const mobileRegex = /^0[0-9]{9}$/; // must start with 0 and total 10 digits

        if (!mobile || mobile.length === 0) {
            return 'หมายเลขโทรศัพท์มือถือไม่ถูกต้อง';
        }

        if (!mobileRegex.test(mobile)) {
            return 'หมายเลขโทรศัพท์มือถือไม่ถูกต้อง';
        }

        return ''; // valid
    };

    handleMobileKeyDown = (event) => {
        const allowedKeys = [
            "Backspace",
            "Delete",
            "Tab",
            "Escape",
            "Enter",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End"
        ];

        if (allowedKeys.includes(event.key)) {
            return;
        }

        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
        }
    };

    //SR2.0
    async callApiSR20OtpStep01(mobile, codeRegister, Source, RefLang, LoyaltyMemberId) {
        document.body.classList.add('wait-cursor');

        const timestamp = Math.floor(Date.now() / 1000);

        const payload = {
            codereg: codeRegister,
            RefLang: RefLang,
            Timestamp: timestamp,
            MobilePhone: mobile,
            Source: Source,
            LoyaltyMemberId: LoyaltyMemberId
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/SR20OtpStep01`, requestOptions);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('API call error :', error);
            return null;
        } finally {
            document.body.classList.remove('wait-cursor');
        }
    }

    async callApiSR20OtpStep02(mobile, codeRegister, Source, RefLang, LoyaltyMemberId, OtpId, RefCode, Otp) {
        document.body.classList.add('wait-cursor');

        const timestamp = Math.floor(Date.now() / 1000);

        const payload = {
            codereg: codeRegister,
            RefLang: RefLang,
            Timestamp: timestamp,
            MobilePhone: mobile,
            Source: Source,
            LoyaltyMemberId: LoyaltyMemberId,
            OtpId: OtpId,
            RefCode: RefCode,
            Otp: Otp
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/SR20OtpStep02`, requestOptions);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('API call error :', error);
            return null;
        } finally {
            document.body.classList.remove('wait-cursor');
        }
    }

    openOtpModal = async (mobileParam, codeRegisterParam) => {
        const { otpTimerId } = this.state;

        const mobile = mobileParam;
        const codeRegister = codeRegisterParam;

        const mobileError = this.validateMobileNumber(mobile);
        if (mobileError) {
            this.setState({
                registerMsgMobile: mobileError,
                showOtpModal: false
            });
            return;
        }

        if (otpTimerId) {
            clearInterval(otpTimerId);
        }

        const data = await this.callApiSR20OtpStep01(
            mobile,
            codeRegister,
            "Profile",
            "th",
            ""
        );

        if (data) {
            if (data.responseCode == "OK") {
                this.setState(
                    {
                        showOtpModal: true,
                        otpValues: ['', '', '', '', '', ''],
                        otpTimeLeft: 60,
                        otpCanResend: false,
                        otpMessage: '',
                        otpRefCode: data.returnObj.refCode,
                        otpRunId: data.returnObj.otpId,
                        otpMaxError: false,
                        registerMsgMobile: ''
                    },
                    () => {
                        this.startOtpTimer();

                        if (this.otpInputRefs[0]) {
                            this.otpInputRefs[0].focus();
                        }
                    }
                );
            } else {
                this.setState({
                    registerMsgMobile: data.responseMessage
                });
                /*
                ?.replace("Invalid mobile number", "เบอร์โทรศัพท์ไม่ถูกต้อง")
                        ?.replace("Invalid OTP", "รหัส OTP ไม่ถูกต้อง")
                        ?.replace(
                            "The limit for OTP entered with this number has been reached.",
                            "หมายเลขนี้มีการกรอกรหัส OTP เกินจำนวนที่กำหนด"
                        )
                        ?.replace("Please try again after", "กรุณาลองใหม่อีกครั้งในอีก")
                        ?.replace("minutes", "นาที")
                */
            }
        } else {
            this.setState({
                registerMsgMobile: 'An unexpected error occurred on the server. Please try again.'
            });
        }
    };

    closeOtpModal = () => {
        if (this.state.otpTimerId) {
            clearInterval(this.state.otpTimerId);
        }

        this.setState({
            showOtpModal: false,
            otpTimerId: null
        });
    };

    startOtpTimer = () => {
        if (this.state.otpTimerId) {
            clearInterval(this.state.otpTimerId);
        }

        const timerId = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.otpTimeLeft <= 1) {
                    clearInterval(timerId);
                    return {
                        otpTimeLeft: 0,
                        otpCanResend: true,
                        otpTimerId: null
                    };
                }

                return {
                    otpTimeLeft: prevState.otpTimeLeft - 1
                };
            });
        }, 1000);

        this.setState({ otpTimerId: timerId });
    };

    formatOtpTime = (sec) => {
        return `00:${String(sec).padStart(2, '0')}`;
    };

    handleOtpChange = (index, event) => {
        const value = event.target.value.replace(/\D/g, '').slice(0, 1);

        this.setState((prevState) => {
            const newOtpValues = [...prevState.otpValues];
            newOtpValues[index] = value;
            return { otpValues: newOtpValues, otpMessage: '' };
        }, () => {
            if (value && index < 5 && this.otpInputRefs[index + 1]) {
                this.otpInputRefs[index + 1].focus();
            }
        });
    };

    handleOtpKeyDown = (index, event) => {
        if (event.key === 'Backspace' && !this.state.otpValues[index] && index > 0) {
            if (this.otpInputRefs[index - 1]) {
                this.otpInputRefs[index - 1].focus();
            }
        }
    };

    handleOtpPaste = (event) => {
        event.preventDefault();

        const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        const newOtpValues = ['', '', '', '', '', ''];

        pasted.split('').forEach((char, i) => {
            newOtpValues[i] = char;
        });

        this.setState({ otpValues: newOtpValues, otpMessage: '' }, () => {
            const lastIndex = Math.min(pasted.length, 6) - 1;
            if (lastIndex >= 0 && this.otpInputRefs[lastIndex]) {
                this.otpInputRefs[lastIndex].focus();
            }
        });
    };

    handleResendOtp = async () => {
        const { otpTimerId, codeRegister } = this.state;

        const mobile = this.getOtpMobile();

        if (otpTimerId) {
            clearInterval(otpTimerId);
        }

        // #region "call API Get OTP"
        const data = await this.callApiSR20OtpStep01(mobile, codeRegister, "Profile", "th", "");

        if (data) {
            if (data.responseCode == "OK") {
                this.setState(
                    {
                        showOtpModal: true,
                        otpValues: ['', '', '', '', '', ''],
                        otpTimeLeft: 60,
                        otpCanResend: false,
                        otpMessage: '',
                        otpRefCode: data.returnObj.refCode,
                        otpRunId: data.returnObj.otpId,
                        otpMaxError: false,
                        registerMsgMobile: ''
                    },
                    () => {
                        this.startOtpTimer();

                        if (this.otpInputRefs[0]) {
                            this.otpInputRefs[0].focus();
                        }
                    }
                );
            } else {
                this.setState(
                    {
                        otpMessage: data.responseMessage
                    });
            }
        } else {
            this.setState({ otpMessage: 'An unexpected error occurred on the server. Please try again.' });
        }
        // #endregion
    };

    handleVerifyOtp = async () => {
        const { otpRunId, otpRefCode, otpValues, otpTimerId } = this.state;
        const otpCode = otpValues.join("");

        if (otpCode.length !== 6) {
            this.setState(
                { otpMessage: "รหัส OTP ไม่ถูกต้อง" },//Please enter complete 6-digit OTP.
                () => this.chkEnableBtnSubmit()
            );
            return;
        }

        try {
            // #region "call API Verify OTP"
            const data = await this.callApiSR20OtpStep02("", "", "Profile", "th", "", otpRunId, otpRefCode, otpCode);

            if (data) {
                if (data.responseCode === "OK") {
                    if (otpTimerId) {
                        clearInterval(otpTimerId);
                    }

                    const finalMobile = this.state.isEditMobile
                        ? this.state.newMobile
                        : this.state.mobile;

                    this.setState({
                        otpMessage: '',
                        showOtpModal: false,
                        otpTimerId: null,
                        mobileVerified: true,
                        otpMaxError: false,
                        verifiedMobileNumber: finalMobile,
                        mobile: finalMobile,
                        newMobile: "",
                        isEditMobile: false,
                        registerMsgMobile: "",
                        disabledBtnOtp: true
                    },
                        () => this.chkEnableBtnSubmit());
                } else {
                    if (data.responseCode === "ErrorMax") {
                        this.setState({
                            otpMessage: data.responseMessage,
                            otpMaxError: true
                        },
                            () => this.chkEnableBtnSubmit());
                    }
                    else {
                        this.setState(
                            {
                                otpMessage: data.responseMessage,
                                otpMaxError: false
                            },
                            () => this.chkEnableBtnSubmit()
                        );

                        this.setState({
                            registerMsgMobile: data.responseMessage
                        });
                    }
                    return;
                }
            } else {
                this.setState({ otpMessage: 'รหัส OTP ไม่ถูกต้อง' },
                    () => this.chkEnableBtnSubmit());
                return;
            }
            // #endregion
        } catch (error) {
            console.error('Verify OTP error:', error);
            this.setState({ otpMessage: 'รหัส OTP ไม่ถูกต้อง' },
                () => this.chkEnableBtnSubmit());
        }
    };

    chkEnableBtnSubmit = () => {
        const {
            firstname,
            lastname,
            mobileVerified,
            languagePreference,
            receiveNews,
            receiveNewsSMS,
            receiveNewsEmail,
            agree1
        } = this.state;

        let disabledBtnSubmit = false;
        let registerMsgFname = "";
        let registerMsgLname = "";

        if (firstname === "") {
            disabledBtnSubmit = true;
        }

        if (lastname === "") {
            disabledBtnSubmit = true;
        }

        if (mobileVerified === false) {
            disabledBtnSubmit = true;
        }

        if (languagePreference === "") {
            disabledBtnSubmit = true;
        }

        //if (receiveNews === false) {
        //    disabledBtnSubmit = true;
        //}

        //if (receiveNewsSMS === false && receiveNewsEmail === false) {
        //    disabledBtnSubmit = true;
        //}

        if (agree1 === false) {
            disabledBtnSubmit = true;
        }

        this.setState({
            registerMsgFname,
            registerMsgLname,
            disabledBtnSubmit: disabledBtnSubmit
        });
    };

    handleChangeMobile = () => {
        this.setState({
            isEditMobile: true,
            newMobile: "",
            mobileVerified: false,
            registerMsgMobile: ""
        });
    };

    cancelChangeMobile = () => {
        this.setState({
            isEditMobile: false,
            newMobile: "",
            mobileVerified: true,
            registerMsgMobile: ""
        });
    };

    getOtpMobile = () => {
        const { isEditMobile, mobile, newMobile } = this.state;
        return isEditMobile ? newMobile : mobile;
    };

    render() {
        const { userInfo, submitting, birthdayd, birthdaym, submittingProfile, salutation, firstname, lastname, firstnameth, lastnameth, mobile, successMsg, failMsg, registerMsgFname, registerMsgLname, failMsg2, disabledBtnOtp, disabledBtnSubmit, languagePreference, receiveNews, receiveNewsSMS, receiveNewsEmail, receiveNewsCss, showOtpModal, otpValues, otpTimeLeft, otpCanResend, otpRefCode, otpMessage, mobileVerified, otpMaxError, registerMsgLanguage, registerMsgReceive, verifiedMobileNumber, agree1, registerMsgAgree, registerMsgMobile, isEditMobile, newMobile } = this.state;

        const getDaysInMonth = (month) => {
            const daysInMonth = {
                '01': 31, // January
                '02': 29, // February
                '03': 31, // March
                '04': 30, // April
                '05': 31, // May
                '06': 30, // June
                '07': 31, // July
                '08': 31, // August
                '09': 30, // September
                '10': 31, // October
                '11': 30, // November
                '12': 31, // December
            };

            return daysInMonth[month] || 31; // Default to 31 if month is not selected
        };

        const days = Array.from({ length: getDaysInMonth(birthdaym) }, (_, i) => i + 1);

        return (
            <>
                <ThNavHeader />

                {/* Render the user data */}
                <main id="main">
                    <section id="profile_section" className="profileBanner keyboardFocus" aria-label="Profile" tabIndex={-1}>
                        <ThUserMenu />
                    </section>
                    {userInfo ? (
                        <section className="section-dashboard overflow-hidden pb-5">
                            <div className="container mt-4">
                                <div className="row mb-5 px-2">
                                    <div className="col-md-12">
                                        <h3 className="fw-semibold mt-4">ข้อมูลสมาชิก</h3>
                                        <form className="form-sr">
                                            <div className="row">
                                                <div className="col-md-4 mt-3 mb-3">
                                                    <label className="form-label">คำนำหน้า (ไม่จำเป็นต้องระบุ)</label>
                                                    <select className="form-select" name="salutation"
                                                        onChange={this.handleChange}
                                                        value={salutation}>
                                                        <option value="">กรุณาเลือก</option>
                                                        <option value="Mr.">นาย</option>
                                                        <option value="Mrs.">นาง</option>
                                                        <option value="Ms">นางสาว</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">ชื่อ (อังกฤษ) <span className="text-green-1">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Name" name="firstname" onChange={this.handleChange} defaultValue={firstname} />
                                                    <div className="text-start mt-1 text-alert-2">
                                                        {registerMsgFname}
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">นามสกุล (อังกฤษ) <span className="text-green-1">*</span></label>
                                                    <input type="text" className="form-control" placeholder="Last Name" name="lastname" onChange={this.handleChange} defaultValue={lastname} />
                                                    <div className="text-start mt-1 text-alert-2">
                                                        {registerMsgLname}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">ชื่อ ภาษาไทย (ไม่จำเป็นต้องระบุ)</label>
                                                    <input type="text" className="form-control" placeholder="ชื่อ ภาษาไทย (ไม่จำเป็นต้องระบุ)" name="firstnameth" onChange={this.handleChange} defaultValue={firstnameth} />
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">นามสกุล ภาษาไทย (ไม่จำเป็นต้องระบุ)</label>
                                                    <input type="text" className="form-control" placeholder="นามสกุล ภาษาไทย (ไม่จำเป็นต้องระบุ)" name="lastnameth" onChange={this.handleChange} defaultValue={lastnameth} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <hr className="my-3" />
                                                </div>
                                            </div>
                                            <p className="text-black"><strong>คุณสามารถคลิกเพื่อเปลี่ยนชื่อบัญชีและรหัสผ่านของคุณ</strong></p>
                                            <div className="row mb-3">
                                                <label className="form-label">ชื่อบัญชี</label>
                                                <div className="col-12 col-md-5 mb-2">
                                                    <input type="text" className="form-control" placeholder="Username" disabled defaultValue={userInfo.email} />
                                                </div>
                                                <div className="col-12 mb-2">
                                                    <Link to="/userprofileemail" className="btn btn-outline-green rounded-pill px-4 text-decoration-none">เปลี่ยนชื่อผู้ใช้</Link>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-8 col-md-7 mb-2">
                                                    <label className="form-label">รหัสผ่าน</label>
                                                    <div className="col-12 col-md-5 mb-2">

                                                    </div>
                                                    <div className="col-12 mb-2">
                                                        <Link to="/userprofilepwd" className="btn btn-outline-green rounded-pill px-4 text-decoration-none">เปลี่ยนรหัสผ่าน</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <p><strong>คุณจะได้รับสิทธิพิเศษในวันเกิดเมื่อคุณปรับระดับเป็น Gold</strong></p>
                                            <p className="h6">วันเกิดของฉัน</p>
                                            <div className="row g-3">
                                                {userInfo.displayBirthday ? (
                                                    <div className="col-md-3 mb-3">
                                                        {this.formatDate(userInfo.displayBirthday).slice(0, -5)}
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="col-md-3 mb-3">
                                                            <select name="birthdaym" value={birthdaym} onChange={this.handleChange} className="form-select">
                                                                <option value="">เดือน</option>
                                                                <option value="01">ม.ค.</option>
                                                                <option value="02">ก.พ.</option>
                                                                <option value="03">มี.ค.</option>
                                                                <option value="04">เม.ย.</option>
                                                                <option value="05">พ.ค.</option>
                                                                <option value="06">มิ.ย.</option>
                                                                <option value="07">ก.ค.</option>
                                                                <option value="08">ส.ค.</option>
                                                                <option value="09">ก.ย.</option>
                                                                <option value="10">ต.ค.</option>
                                                                <option value="11">พ.ย.</option>
                                                                <option value="12">ธ.ค.</option>
                                                            </select>&nbsp;
                                                            <select name="birthdayd" value={birthdayd} onChange={this.handleChange} className="form-select">
                                                                <option value="">วัน</option>
                                                                {days.map((day) => (
                                                                    <option key={day} value={day}>
                                                                        {day}
                                                                    </option>
                                                                ))}
                                                            </select>&nbsp;
                                                            <button type="button" className="btn btn-primary rounded-pill px-3 d-none" disabled={submitting} onClick={this.handleSubmit}>
                                                                {submitting ? 'Update...' : 'Update'}
                                                            </button>
                                                            <div className="text-start text-alert-2">
                                                                {failMsg2}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>

                                            {verifiedMobileNumber === null ? (
                                                <>
                                                    <div className="row">
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">เบอร์โทรศัพท์<span class="text-green-1">*</span></label>
                                                            <div className="input-group mb-3">
                                                                <input
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    className={`form-control rounded ${mobileVerified ? "is-valid" : ""}`}
                                                                    name="mobile"
                                                                    value={mobile}
                                                                    onChange={this.handleChange}
                                                                    onKeyDown={this.handleMobileKeyDown}
                                                                    maxLength={10}
                                                                    readOnly={mobileVerified}
                                                                />

                                                                {!mobileVerified && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-green rounded-pill px-4 text-decoration-none ms-3"
                                                                        disabled={disabledBtnOtp}
                                                                        onClick={() => this.openOtpModal(mobile, "")}
                                                                    >
                                                                        เพิ่ม
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="text-start mt-1 text-alert-2">
                                                            {registerMsgMobile}
                                                        </div>
                                                    </div>
                                                </>
                                            ) : isEditMobile ? (
                                                <div className="row">
                                                    <div className="col-md-4 mb-3">
                                                        <h4 className="mb-4">เปลี่ยนเบอร์โทรศัพท์</h4>

                                                        <div className="mb-3">
                                                                <label className="form-label">เบอร์โทรศัพท์ปัจจุบัน<span class="text-green-1">*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={verifiedMobileNumber}
                                                                readOnly
                                                                disabled
                                                            />
                                                        </div>

                                                        <div className="mb-3">
                                                                <label className="form-label">เบอร์โทรศัพท์ใหม่<span class="text-green-1">*</span></label>
                                                            <input
                                                                type="text"
                                                                inputMode="numeric"
                                                                className={`form-control rounded ${mobileVerified ? "is-valid" : ""}`}
                                                                name="newMobile"
                                                                value={newMobile}
                                                                onChange={this.handleChange}
                                                                onKeyDown={this.handleMobileKeyDown}
                                                                maxLength={10}
                                                                autocomplete="block-auto-mobile"
                                                            />
                                                        </div>

                                                        <div className="text-start mt-1 text-alert-2">
                                                            {registerMsgMobile}
                                                        </div>

                                                        <div className="d-flex gap-2 mt-3">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary rounded-pill px-4 text-decoration-none"
                                                                disabled={disabledBtnOtp}
                                                                onClick={() => this.openOtpModal(newMobile, "")}
                                                            >
                                                                รับรหัส OTP
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn btn-gray rounded-pill px-4 text-decoration-none"
                                                                onClick={this.cancelChangeMobile}
                                                            >
                                                                ยกเลิก
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="row">
                                                    <div className="col-md-4 mb-3">
                                                                <label className="form-label">เบอร์โทรศัพท์<span class="text-green-1">*</span></label>
                                                        <div className="input-group mb-3">
                                                            <input
                                                                type="text"
                                                                inputMode="numeric"
                                                                className={`form-control rounded ${mobileVerified ? "is-valid" : ""}`}
                                                                name="mobile"
                                                                value={verifiedMobileNumber}
                                                                maxLength={10}
                                                                readOnly={true}
                                                                disabled
                                                            />

                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-green rounded-pill px-4 text-decoration-none ms-3"
                                                                onClick={this.handleChangeMobile}
                                                            >
                                                                เปลี่ยน
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <hr className="mt-2 mb-3" />
                                                </div>
                                            </div>

                                            <div className="row form-check-term">
                                                <div className="col-md-12 mb-3">
                                                    <p className="fw-bold mb-3 fs-6">
                                                        <label className="form-label fw-bold mb-3 d-block">การตั้งค่าและเงื่อนไข</label>
                                                    </p>

                                                    {/* Language Preference (RADIO) */}
                                                    <div className="mb-3">
                                                        <label className="form-label fw-medium d-block">
                                                            ภาษาที่ต้องการสำหรับรับข้อมูลข่าวสาร <span class="text-green-1">*</span>
                                                        </label>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="languagePreference"
                                                                id="lang-en"
                                                                value="en"
                                                                checked={languagePreference?.toLowerCase() === "en"}
                                                                onChange={this.handleChange}
                                                            />
                                                            <label className="form-check-label" htmlFor="lang-en">English</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="languagePreference"
                                                                id="lang-th"
                                                                value="th"
                                                                checked={languagePreference?.toLowerCase() === "th"}
                                                                onChange={this.handleChange}
                                                            />
                                                            <label className="form-check-label" htmlFor="lang-th">ไทย</label>
                                                        </div>
                                                        <div className="text-danger small mt-1" id="lang-error">
                                                            {registerMsgLanguage}
                                                        </div>
                                                    </div>

                                                    {/* Sign up promotions */}
                                                    <div className="mb-3">
                                                        <div className="form-check">
                                                            <input type="checkbox" className="form-check-input channel-checkbox" name="receiveNews" checked={receiveNews}
                                                                onChange={this.handleChange} />
                                                            <label className="form-check-label d-block" htmlFor="promo-checkbox">
                                                                สมัครเพื่อรับโปรโมชันและข่าวสารพิเศษจากสตาร์บัคส์ <span class="text-green-1">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {/* Preferred channel */}
                                                    <div className={receiveNewsCss}>
                                                        <p className="fw-medium mb-2">ฉันต้องการรับข้อมูลข่าวสารผ่าน:</p>
                                                        <div className="form-check form-check-inline">
                                                            <input type="checkbox" className="form-check-input channel-checkbox" name="receiveNewsEmail" checked={receiveNewsEmail}
                                                                onChange={this.handleChange} />
                                                            <label className="form-check-label" htmlFor="channel-email">อีเมล</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input type="checkbox" className="form-check-input channel-checkbox" name="receiveNewsSMS" checked={receiveNewsSMS}
                                                                onChange={this.handleChange} />
                                                            <label className="form-check-label" htmlFor="channel-sms">SMS</label>
                                                        </div>
                                                        <div className="text-danger small mt-1">
                                                            {registerMsgReceive}
                                                        </div>
                                                    </div>

                                                    {/* Agree terms */}
                                                    <div className="mb-4">
                                                        <div className="form-check">
                                                            <input type="checkbox" className="form-check-input" name="agree1" checked={agree1}
                                                                onChange={this.handleChange} />
                                                            <label className="form-check-label d-block" htmlFor="agree-terms">
                                                                ฉันยอมรับ <a href="https://www.starbucks.co.th/online-policies/privacy-notice/" target="_blank">นโยบายความเป็นส่วนตัว</a> และ <a href="https://www.starbucks.co.th/online-policies/terms-of-use/" target="_blank">ข้อกำหนดการใช้งาน</a>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="text-danger small mt-1">
                                                        {registerMsgAgree}
                                                    </div>
                                                    <p className="font-15px"><span class="text-green-1">*</span> คุณสามารถอัปเดตการตั้งค่าของคุณได้บนเว็บไซต์สตาร์บัคส์ ผ่านหน้าโปรไฟล์สมาชิก</p>
                                                    {/* Submit */}
                                                    <button
                                                        className="btn btn-primary rounded-pill px-4 text-decoration-none"
                                                        id="submit-btn"
                                                        disabled={disabledBtnSubmit}
                                                        onClick={this.handleSubmitProfile}
                                                    >
                                                        อัปเดต
                                                    </button>
                                                </div>
                                            </div>

                                            <div>
                                                {/*<button type="button" className="btn btn-primary rounded-pill px-3" disabled={submittingProfile} onClick={this.handleSubmitProfile}>*/}
                                                {/*    {submittingProfile ? 'Update...' : 'Update'}*/}
                                                {/*</button>*/}
                                                <div className="text-start text-green-1">
                                                    {successMsg}
                                                </div>
                                                <div className="text-start text-alert-2">
                                                    {failMsg}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <hr className="mt-2 mb-3" />
                                                </div>
                                            </div>
                                            <div className="row form-check-term">
                                                <div className="col-md-12 mb-3">
                                                    <div className="text-start mt-4"><Link to="/thuserprofiledelete" className="btn btn-outline-green rounded-pill px-4 text-decoration-none">ยกเลิกบัญชีสมาชิก</Link></div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {/*Modal OTP*/}
                            {showOtpModal && (
                                <>
                                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog modal-fullscreen">
                                            <div className="modal-content justify-content-center">
                                                <div className="container">
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 col-md-6">
                                                            <div className="modal-header border-bottom-0">
                                                                <h1 className="modal-title fs-5">กรอกรหัสยืนยัน</h1>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close"
                                                                    onClick={this.closeOtpModal}
                                                                ></button>
                                                            </div>

                                                            <div className="modal-body">
                                                                <p>กรุณาใส่รหัสยืนยัน 6 หลักที่ส่งไปยัง {this.getOtpMobile()}</p>

                                                                <div className="row g-2 mb-3">
                                                                    <div className="col-auto d-flex gap-2">
                                                                        {otpValues.map((value, index) => (
                                                                            <input
                                                                                key={index}
                                                                                ref={(el) => (this.otpInputRefs[index] = el)}
                                                                                type="text"
                                                                                inputMode="numeric"
                                                                                maxLength="1"
                                                                                className="form-control form-control-lg text-center rounded-2 px-2 py-3 otp-input"
                                                                                style={{ width: '56px' }}
                                                                                value={value}
                                                                                onChange={(e) => this.handleOtpChange(index, e)}
                                                                                onKeyDown={(e) => this.handleOtpKeyDown(index, e)}
                                                                                onPaste={this.handleOtpPaste}
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>

                                                                <p className="fw-medium">
                                                                    Ref. Code: <span className="text-green-1">{otpRefCode}</span>
                                                                </p>

                                                                {otpMessage && (
                                                                    <p className="text-alert-2">{otpMessage}</p>
                                                                )}

                                                                {!otpCanResend ? (
                                                                    <p className="fw-medium">
                                                                        {!otpMaxError && (
                                                                            <>
                                                                                ส่งรหัสอีกครั้งใน{" "}
                                                                                <span className="text-muted">
                                                                                    <strong>{this.formatOtpTime(otpTimeLeft)}</strong>
                                                                                </span>
                                                                            </>
                                                                        )}
                                                                    </p>
                                                                ) : (
                                                                    <p>
                                                                        {!otpMaxError && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-link p-0 fw-medium text-green-1 text-decoration-underline"
                                                                                onClick={this.handleResendOtp}
                                                                            >
                                                                                ส่งรหัสอีกครั้ง
                                                                            </button>
                                                                        )}
                                                                    </p>
                                                                )}

                                                                <div className="mt-4 d-flex gap-2">
                                                                    {!otpMaxError && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary rounded-pill px-4"
                                                                            onClick={this.handleVerifyOtp}
                                                                        >
                                                                            ตรวจสอบ OTP
                                                                        </button>
                                                                    )}

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-secondary rounded-pill px-4 d-none"
                                                                        onClick={this.closeOtpModal}
                                                                    >
                                                                        ปิด
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-backdrop fade show"></div>
                                </>
                            )}
                        </section>
                    ) : (
                        <>
                            {/*Loading*/}
                            <div className="col-md-5">
                                <div className="text-center" style={{ height: '160px' }} />
                                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                    <h3 className="text-white">LOADING ...</h3>
                                    <img src="media/loading-gif.gif" alt="Loading..." width={80} className="img-fluid" />
                                </div>
                                <div style={{ height: '100px' }} />
                            </div>
                        </>
                    )}
                </main>

                <ThNavFooter />
            </>
        );
    }
}
